import { render, staticRenderFns } from "./PromotedUserList.vue?vue&type=template&id=63fcb5f5&scoped=true&"
import script from "./PromotedUserList.vue?vue&type=script&lang=ts&"
export * from "./PromotedUserList.vue?vue&type=script&lang=ts&"
import style0 from "./PromotedUserList.vue?vue&type=style&index=0&id=63fcb5f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fcb5f5",
  null
  
)

export default component.exports